module.exports = __webpack_public_path__ + "static/clients.7850d7eb.svg";


//////////////////
// WEBPACK FOOTER
// ./static/clients.svg
// module id = 92
// module chunks = 23998963383738 263791100135453